import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { BOM_POSITION_API } from "../apiRoutes";

const mutateUpdatePosition = async ({
  data,
  id,
}: {
  data: FieldValues;
  id: string;
}) => {
  return await axiosAuth.put(`${BOM_POSITION_API}/${id}`, data);
};

const useUpdatePositionMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
      id: string;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdatePosition,
    ...queryParams,
  });

export default useUpdatePositionMutation;
